<template>
    <div class="attactpanel" v-if="attachCfg.fkvalue">
        <div class="attachtitle">
            附件上传
        </div>
        <div class="attachserch"><a-input-search v-model="searchvalue" placeholder="请输入文件名" style="width: 100%;" @search="onSearch" /></div>
        <div class="attachfilelist">
            <a-tree
                :loading="loading"
                v-model="checkedKeys"
                :replaceFields="{ children: 'children', title: 'filename', key: 'control_no' }"
                :tree-data="treeData"
                :show-line="true"
                :defaultExpandAll="true"
                :expanded-keys="expandedKeys"
                @expand="onExpand"
                @rightClick="onRightClick"
                @click="onClick"
            />
            <v-contextmenu ref="contextmenu_up">
                <v-contextmenu-item @click="handlePreview" v-if="!isDir"><a-icon type="link" />预览</v-contextmenu-item>
                <v-contextmenu-item @click="handleDownload" v-if="!isDir"><a-icon type="download" />下载</v-contextmenu-item>
                <v-contextmenu-item v-if="isDir">
                    <!-- 上传文件按钮 -->
                    <a-upload
                        v-show="!isnew"
                        :disabled="isnew"
                        action="./api/main/attach/saveAttach"
                        :headers="headers"
                        :data="attach"
                        :multiple="true"
                        :file-list="fileList2"
                        :showUploadList="false"
                        :before-upload="beforeUpload"
                        @change="handleChangeOfFile"
                    >
                        <a-icon type="file-add" />上传
                    </a-upload>
                </v-contextmenu-item>
                <v-contextmenu-item @click="handleRemove" v-if="isDelete"><a-icon type="delete" />删除</v-contextmenu-item>
            </v-contextmenu>
        </div>
    </div>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters: userMapGetters } = createNamespacedHelpers("user");
export default {
    name: "AttachUploadZJ",
    props: ["isnew", "attachCfg"],
    data() {
        return {
            loading: false,
            queryParams: {},
            searchvalue: "",
            attach: {},
            headers: {}, //上传请求头部
            fileList0: [],
            fileList1: [],
            fileList2: [],
            fileList: [],
            treeData: [], //树形数据
            checkedKeys: [],
            selectedKeys: [],
            expandedKeys: [],
            file: {},
            isDelete: true,
            isDir: true,
            attachsource: ""
        };
    },
    computed: {
        ...userMapGetters(["getUserInfo", "getToken"])
    },
    watch: {
        attachCfg: {
            handler(newVal) {
                // 显示编辑窗口时加载数据
                if (this.attachCfg.fkvalue) {
                    this.treeData = [];
                    this.queryAttachFileList();
                }
            },
            immediate: true,
            deep: true
        }
    },
    created() {
        this.headers.Authorization = `Bearer ` + this.getToken;
    },
    activated() {
        this.fileList = [];
    },
    methods: {
        queryAttachFileList() {
            this.loading = true;
            this.$FG_http
                .post(
                    "./api/main/attach/queryAttach",
                    {
                        queryParams: this.attachCfg
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.loading = false;
                    if (success) {
                        if (data.data) {
                            // 设置当前编辑数据
                            this.fileList = data.data.attach;
                            this.fileList0 = this.fileList;
                            this.fileList1 = [];
                            this.fileList2 = [];
                            this.treeData = data.data.tree;
                            if (this.treeData.length > 0) {
                                this.expandedKeys.push(this.treeData[0].control_no);
                            }
                        } else {
                            // 加载的数据不存在则提示错误并关闭编辑窗口
                            this.$FG_message.error("P0002");
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则关闭弹窗
                        this.$FG_message.error("P0002");
                    }
                });
        },
        beforeUpload(file) {
            this.loading = true;
            if (this.attachsource) {
                this.attachCfg.attachsource = this.attachsource;
            }
            this.attach.data = JSON.stringify(this.attachCfg);
            return true;
        },
        handleChangeOfFolder(info) {
            if (info.file.status === "removed") {
                this.deleteAttach(info.file.uid);
            }
            let fileList = [...info.fileList];
            // fileList = fileList.slice(-1); //保留最新附件
            if (info.file.status === "done") {
                //返回response
                fileList = fileList.map((file) => {
                    if (file.response) {
                        file.uid = file.response.data.ID;
                        file.url = file.response.data.ID;
                    }
                    return file;
                });
            }
            this.fileList1 = fileList;
            this.fileList = this.fileList0.concat(this.fileList1).concat(this.fileList2);
            //附件是否都已上传成功
            let state = 1;
            for (let i = 0; i < this.fileList.length; i++) {
                if (this.fileList[i].status !== "done") {
                    state = 0;
                    break;
                }
            }
            if (this.fileList.length > 0 && state === 1) {
                this.queryAttachFileList();
            }
        },
        handleChangeOfFile(info) {
            if (info.file.status === "removed") {
                this.deleteAttach(info.file.uid);
            }
            let fileList = [...info.fileList];
            // fileList = fileList.slice(-1); //保留最新附件
            if (info.file.status === "done") {
                //返回response
                fileList = fileList.map((file) => {
                    if (file.response) {
                        file.uid = file.response.data.ID;
                        file.url = file.response.data.ID;
                    }
                    return file;
                });
            }
            this.fileList2 = fileList;
            this.fileList = this.fileList0.concat(this.fileList2).concat(this.fileList1);
            //附件是否都已上传成功
            let state = 1;
            for (let i = 0; i < this.fileList.length; i++) {
                if (this.fileList[i].status !== "done") {
                    state = 0;
                    break;
                }
            }
            if (this.fileList.length > 0 && state === 1) {
                this.queryAttachFileList();
            }
        },
        onExpand(expandedKeys) {
            this.expandedKeys = expandedKeys;
        },

        onClick(event, node) {
            event.stopPropagation(); // 阻止事件冒泡
            // 判断树形第几层
            if (node.pos.split("-").length <= 2) {
                this.isDelete = false;
                this.attachsource = node._props.dataRef.attachsource;
                // 是否为文件夹
                this.isDir = node._props.dataRef.file_type === 1;
                this.file = {
                    uid: node._props.dataRef.id,
                    name: node._props.dataRef.filename
                };
                const x = event.x; //event.screenX - 300 + event.currentTarget.clientWidth + 50;
                // 因为我放在页面上的box有滚动条，所以需要减掉该盒子的scrollTop
                const y = event.y; //event.currentTarget.offsetHeight + event.currentTarget.offsetTop + 150;
                const postition = {
                    top: y,
                    left: x
                };
                this.$refs.contextmenu_up.show(postition);
            }
        },
        onRightClick({ event, node }) {
            // 判断树形第几层
            if (node.pos.split("-").length > 2) {
                //判断当前用户是否为上传人
                if (node._props.dataRef.uploaduserid !== this.getUserInfo.id) {
                    this.isDelete = false;
                } else {
                    this.isDelete = true;
                }
                this.attachsource = node._props.dataRef.attachsource;
                // 是否为文件夹
                this.isDir = node._props.dataRef.file_type === 1;
                this.file = {
                    uid: node._props.dataRef.id,
                    name: node._props.dataRef.filename
                };
                const x = event.x; //event.screenX - 300 + event.currentTarget.clientWidth + 50;
                // 因为我放在页面上的box有滚动条，所以需要减掉该盒子的scrollTop
                const y = event.y; //event.currentTarget.offsetHeight + event.currentTarget.offsetTop + 150;
                const postition = {
                    top: y,
                    left: x
                };
                this.$refs.contextmenu_up.show(postition);
            }
        },
        handleRemove() {
            this.loading = true;
            this.$FG_http
                .post("./api/main/attach/deleteAttach", {
                    id: this.file.uid
                })
                .then(({ success, data, errMsg }) => {
                    this.loading = false;
                    if (success) {
                        this.queryAttachFileList();
                    }
                });
        },
        handlePreview() {
            this.loading = true;
            this.$FG_http
                .post(
                    "./api/main/attach/previewAttach",
                    {
                        id: this.file.uid
                    },
                    {
                        responseType: "blob",
                        showSuccess: false,
                        timeout: 60000 * 60
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.loading = false;
                    if (success) {
                        let binaryData = [];
                        binaryData.push(data);
                        this.file.url = window.URL.createObjectURL(new Blob(binaryData, { type: "application/pdf" }));
                        window.open(this.file.url, this.file.name);
                    } else {
                        this.$FG_message.error("P0002");
                    }
                });
        },
        handleDownload() {
            this.loading = true;
            this.$FG_http
                .post(
                    "./api/main/attach/downloadAttach",
                    {
                        id: this.file.uid
                    },
                    {
                        responseType: "blob",
                        showSuccess: false,
                        timeout: 60000 * 60
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.loading = false;
                    if (success) {
                        let aLink = document.createElement("a");
                        let blob = new Blob([data]);
                        aLink.href = URL.createObjectURL(blob);
                        aLink.setAttribute("download", this.file.name); // 设置下载文件名称
                        aLink.click(); //执行下载
                        document.body.appendChild(aLink);
                        URL.revokeObjectURL(aLink.href); //释放url
                        document.body.removeChild(aLink); //释放标签
                    } else {
                        this.$FG_message.error("P0002");
                    }
                });
        },
        onSearch() {
            this.fileList = [];
            this.attachCfg.filename = this.searchvalue;
            this.queryAttachFileList();
        },
        haveFile() {
            return this.fileList && this.fileList.length > 0;
        }
    },
    mounted() {},
    beforeDestroy() {}
};
</script>
<style lang="scss" scoped>
.attactpanel {
    padding: 5px 10px;
    display: flex;
    flex-flow: column;
    .attachtitle {
        color: #333;
        font-size: 24px;
        font-weight: bold;
        .attachbtn {
            float: right;
            cursor: pointer;
        }
    }
    .attachserch {
        margin: 1em 0 0.5em 0;
    }
    .attachfilelist {
        margin: 10px 0;
    }
}
</style>
